import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/components/feature/HeroSection';
import CategorySection from '@/components/feature/CategorySection';
import FeaturedProducts from '@/components/feature/FeaturedProducts';
import ArticlePreview from '@/components/feature/ArticlePreview';
import PillarArticles from '@/components/feature/PillarArticles';
import ContentSections from '@/components/feature/ContentSections';

export default function Home() {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/en/')) {
      i18n.changeLanguage('en');
    } else if (path.startsWith('/de/')) {
      i18n.changeLanguage('de');
    } else {
      i18n.changeLanguage('pt');
    }
  }, [location.pathname, i18n]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-warm-50">
      <Navbar />
      <main className="flex-1 pt-16 md:pt-20">
        <HeroSection />
        <CategorySection />
        <FeaturedProducts />
        <ArticlePreview />
        <PillarArticles />
        <ContentSections />
      </main>
      <Footer />
    </div>
  );
}